import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

const TwoFactorAuth = () => {
  // const BASE_URL = "https://hb40wwcn-8000.inc1.devtunnels.ms";
  const [otp, setOtp] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [error, setError] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();

  const verifyOTP = async () => {
    try {
      // Retrieve stored current password from localStorage
      const storedCurrentPassword = JSON.parse(
        sessionStorage.getItem("currentpassword")
      );

      // Retrieve user type and access token from localStorage
      const userType = localStorage.getItem("userType");
      const authToken = localStorage.getItem("access_token");

      // Check if entered current password matches the stored one
      if (currentPassword !== storedCurrentPassword.new_password) {
        setError("Current password was not same");

        setPopupVisible(true);
        return;
      }

      if (!authToken) {
        throw new Error("Authentication token not found. Please log in again.");
      }

      // Determine the correct endpoint based on user type
      let endpoint;
      switch (userType) {
        case "superadmin":
          endpoint = "/SuperAdmin_login/verify_otp/";
          break;
        case "admin":
          endpoint = "/Admin_Login/verify_otp/";
          break;
        case "employee":
          endpoint = "/Employee_login/verify_otp/";
          break;
        default:
          throw new Error("Invalid user type for OTP verification.");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}${endpoint}`,
        // `${BASE_URL}${endpoint}`,

        { otp, current_password: storedCurrentPassword.new_password },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (
        response.data.message === "OTP verification successful. 2FA activated."
      ) {
        // Clear user-specific data after successful verification
        localStorage.removeItem("userType");
        localStorage.removeItem("access_token");
        localStorage.removeItem("qr_code_image");
        navigate("/admin-dashboard");
      }
    } catch (error) {
      // Handle backend errors
      const errorResponse = error.response ? error.response.data : {};
      const errorMessage =
        errorResponse.non_field_errors?.[0] ||
        errorResponse.detail ||
        errorResponse.message ||
        error.message ||
        "An error occurred. Please try again.";

      setError(errorMessage);
      setPopupVisible(true);
    }
  };

  return (
    <>
      <div className="bg-gray-900 background w-full h-[100vh] flex items-center">
        <div className="flex justify-center mx-auto w-full h-[70vh] rounded-xl">
          <div className="z-10 relative flex flex-col justify-center w-full md:w-3/5 p-5 md:px-20 rounded-e-2xl">
            <div className="absolute w-[60vw] h-[60vh] -z-10 inset-0 border-2 border-red-600 rounded-xl backdrop-blur-sm bg-red-500/50"></div>
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex justify-center">
              <img
                src={require("../../assets/images/commonImages/ZeroMiddleMan Logo 3.png")}
                alt=""
                className="bg-white px-4 rounded-2xl w-32 md:w-48"
              />
            </div>
            <div className="flex flex-col justify-center items-center gap-4">
              <h2 className="text-white text-3xl md:text-4xl font-semibold">
                Two Factor Authentication
              </h2>
              <div className="w-1/2 relative flex ">
                <input
                  className="px-5 py-2 text-white placeholder-white placeholder:text-lg placeholder:font-semibold outline-none border-b bg-transparent w-full "
                  type={passwordVisible ? "text" : "password"}
                  placeholder="Enter your Current Password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <span
                  className="absolute right-3 top-3 text-xl text-white cursor-pointer"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? <AiFillEyeInvisible /> : <AiFillEye />}
                </span>
              </div>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="px-5 py-2 text-white placeholder-white placeholder:text-lg placeholder:font-semibold outline-none border-b bg-transparent w-1/2"
              />
              <p className="text-white">{error}</p>
              <button
                onClick={verifyOTP}
                className="bg-white px-10 py-2 text-blood font-semibold rounded-md hover:bg-blood hover:text-white"
              >
                Verify OTP
              </button>
            </div>
          </div>
        </div>
      </div>

      {popupVisible && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{error}</p>
            <button onClick={() => setPopupVisible(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};
export default TwoFactorAuth;
